import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'emm-delete-attribute-group-dialog',
    templateUrl: './delete-attribute-group-dialog.component.html',
    styleUrls: ['./delete-attribute-group-dialog.component.scss'],
    standalone: false
})
export class DeleteAttributeGroupDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DeleteAttributeGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit(): void {
        this.dialogRef.updatePosition({ top: '100px' });
    }

    closeAfterSubmit(): void {
        const result = {
            id: this.data.categoryData.id,
            description: this.data.categoryData.description,
        };
        this.dialogRef.close(result);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    OnSubmit(): void {
        this.closeAfterSubmit();
    }
}

